import { connect } from "react-redux";
import Supervisor from './supervisor'
import { bindActionCreators } from "redux";
import { supervisorList, deleteSupervisor } from "services/redux/Valet/Supervisor/action";

const mapStateToProps = (state) => ({
    siteInfo : state.CreateSupervisor.supervisorList,
    deleteSupervisorDetails : state.CreateSupervisor.deleteSupervisor,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        supervisorList,
        deleteSupervisor
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Supervisor);